module.exports = __webpack_public_path__ + "static/Quit Genius-8bb6020994f1ea7b9438f1aa44042c63.jpg";